import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface VolumeIconProps {
    color?: string;
    muted?: boolean;
    className?: string | null;
}

const VolumeIcon: React.FC<VolumeIconProps> = ({
    color = 'currentColor',
    muted = false,
    className = null,
}) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, { [className!]: className !== null }])}
        >
            <path
                d="M19.07 5.71387C20.9447 7.58914 21.9979 10.1322 21.9979 12.7839C21.9979 15.4355 20.9447 17.9786 19.07 19.8539M15.54 9.24387C16.4774 10.1815 17.0039 11.453 17.0039 12.7789C17.0039 14.1047 16.4774 15.3762 15.54 16.3139M11 5.78387L6 9.78387H2V15.7839H6L11 19.7839V5.78387Z"
                stroke={color}
                strokeWidth={muted ? '1' : '2'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default VolumeIcon;
